<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('boxinspection.fourthStepInfo') }}
    </p>
    <hr />
    <div
      v-for="(_, index) in model.box_quantity || 1"
      :key="index"
      class="my-4"
    >
      <div>
        <p>{{ $t('production.box') }} {{ index + 1 }}</p>
        <hr />
      </div>
      <div class="px-3">
        <div class="row" style="overflow-x: auto" v-if="showTable">
          <table
            aria-describedby="table-clusters"
            class="table table-bordered p-4"
          >
            <thead>
              <tr class="cusmtom-thead-color">
                <th
                  scope="col"
                  class="text-center p-3 custom-header-label"
                  v-bind:style="{ minWidth: '100px' }"
                >
                  <strong>{{ $t('boxinspection.measurement') }}</strong>
                </th>
                <th
                  scope="col"
                  class="text-center p-3 custom-header-label"
                  v-bind:style="{ minWidth: '130px' }"
                  v-for="(_, indexSampleQuantity) in model.sample_quantity[
                    index
                  ]"
                  :key="indexSampleQuantity"
                >
                  <strong>{{ indexSampleQuantity + 1 }}</strong>
                </th>

                <th
                  scope="col"
                  class="text-center custom-header-label"
                  v-bind:style="{ minWidth: '100px' }"
                >
                  <strong>{{ $t('common_words.options') }}</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">{{ $t('boxinspection.cluster_number') }}</td>
                <td
                  class="text-center"
                  v-for="(_, indexCluster) in model.sample_quantity[index]"
                  :key="indexCluster"
                >
                  <select-component
                    :class="`mt-3 col-12`"
                    :isMultiple="false"
                    :dataOptions="clusters"
                    :requireClass="`required-cluster_id`"
                    :initialSelection="model.boxes[index][indexCluster].cluster"
                    @onChange="
                      (val) =>
                        (model.boxes[index][indexCluster].cluster = val.selects)
                    "
                  />
                </td>
                <td
                  class="text-center"
                  style="display: table-cell"
                  v-bind:style="{ width: '150px' }"
                >
                  <div class="d-flex justify-content-center mt-3">
                    <a
                      v-if="model.sample_quantity[index] < maxSampleQuantity"
                      v-tooltip.top-center="$t('common_words.add')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="addSampleCol(index)"
                    >
                      <em class="fa fa-plus custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="model.sample_quantity[index] > minSampleQuantity"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="deleteSampleCol(index)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  {{ $t('common_words.weight') }} (lb)
                </td>
                <td
                  class="text-center"
                  v-for="(_, indexWeight) in model.sample_quantity[index]"
                  :key="indexWeight"
                >
                  <fg-input
                    type="number"
                    step="0.1"
                    ref="weight"
                    class="m-3 text-center input-weight"
                    v-model="model.boxes[index][indexWeight].peso"
                    :name="`common_words.weight_${index}_${indexWeight}`"
                    v-validate="modelValidations.weight"
                    :error="
                      getFieldErrorByIndex(
                        'common_words.weight',
                        true,
                        `${index}_${indexWeight}`
                      )
                    "
                  />
                </td>
                <td
                  class="text-center"
                  style="display: table-cell"
                  v-bind:style="{ width: '150px' }"
                >
                  <div class="d-flex justify-content-center mt-3">
                    <a
                      v-if="model.sample_quantity[index] < maxSampleQuantity"
                      v-tooltip.top-center="$t('common_words.add')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="addSampleCol(index)"
                    >
                      <em class="fa fa-plus custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="model.sample_quantity[index] > minSampleQuantity"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="deleteSampleCol(index)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import i18n from 'src/i18n';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      showTable: false,
      minSampleQuantity: 13,
      maxSampleQuantity: 20,
      model: {
        box_quantity: 1,
        sample_quantity: [],
        boxes: {},
      },
      modelValidations: {
        weight: {
          required: true,
          decimal: 2,
          min_value: 0.1,
          max_value: 5,
        },
      },
      clusters: [
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
        { id: 4, name: '4' },
        { id: 5, name: '5' },
        { id: 6, name: '6' },
        { id: 7, name: '7' },
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
        { id: 11, name: '11' },
        { id: 12, name: '12' },
        { id: 13, name: '13' },
        { id: 14, name: '14' },
        { id: 15, name: '15' },
        { id: 16, name: '16' },
        { id: 17, name: '17' },
        { id: 18, name: '18' },
        { id: 19, name: '19' },
        { id: 20, name: '20' },
      ],
    };
  },
  mixins: [MixinPermissions, MixinExport, MixinForm, MixinValidations],
  props: {
    box_quantity: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    box_quantity: {
      handler(newVal) {
        if (newVal && newVal !== this.model.box_quantity) {
          this.model.box_quantity = newVal;
          this.initCajas();
        }
      },
      immediate: true,
    },
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        for (let i = 0; i < this.model.box_quantity; i++) {
          const seenClusters = new Set();

          for (let j = 0; j < this.model.sample_quantity[i]; j++) {
            const cluster = this.model.boxes[i][j].cluster;

            if (!isset(cluster)) {
              return this.validationInputsRequired(`cluster_id`);
            }

            if (seenClusters.has(cluster)) {
              SweetAlert.warning(
                i18n.t('boxinspection.cluster_repeated', {
                  cluster,
                  caja: i + 1,
                  medida: j + 1,
                })
              );

              return false;
            }

            seenClusters.add(cluster);
          }
        }

        this.$emit('on-validated', this.model);

        return res;
      });
    },

    initCajas() {
      for (let i = 0; i < this.model.box_quantity; i++) {
        if (!this.model.boxes[i]) this.model.boxes[i] = {};
        for (let j = 0; j < this.minSampleQuantity; j++) {
          if (!this.model.boxes[i][j]) {
            this.$set(this.model.boxes[i], j, { cluster: j + 1, peso: null });
          }
        }
        this.model.sample_quantity[i] = this.minSampleQuantity;
      }
      this.showTable = true;
    },

    addSampleCol(index) {
      const current = this.model.sample_quantity[index];

      if (current < this.maxSampleQuantity) {
        const newIndex = current; // el siguiente índice disponible
        this.$set(this.model.boxes[index], newIndex, {
          cluster: newIndex + 1,
          peso: null,
        });
        this.$set(this.model.sample_quantity, index, current + 1);
      }
    },

    deleteSampleCol(index) {
      const current = this.model.sample_quantity[index];

      if (current > this.minSampleQuantity) {
        const lastIndex = current - 1;
        this.$delete(this.model.boxes[index], lastIndex);
        this.$set(this.model.sample_quantity, index, lastIndex);
      }
    },
  },
  mounted() {
    this.initCajas();
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));

      const { boxes_quantity, box_inspection_boxes } = editForm;

      this.model = {
        ...this.model,
        box_quantity: boxes_quantity,
      };
      
      box_inspection_boxes.forEach((box, boxIndex) => {
        // Inicializar la caja
        this.$set(this.model.boxes, boxIndex, {});
        
        if (box.box_inspection_clusters && box.box_inspection_clusters.length > 0) {
          // Si hay clusters guardados, usar esos datos
          const clusterCount = box.box_inspection_clusters.length;
          this.$set(this.model.sample_quantity, boxIndex, clusterCount);
          
          box.box_inspection_clusters.forEach((cluster, clusterIndex) => {
            this.$set(this.model.boxes[boxIndex], clusterIndex, {
              cluster: cluster.cluster_number,
              peso: parseFloat(cluster.weight) || null,
            });
          });
        }
      });
    }
  },
};
</script>
